"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReadyQueue = void 0;
const createReadyQueue = (onError = (e) => {
    // eslint-disable-next-line no-console
    console.error("[plugins] onReady callback threw", e);
}) => {
    const queued = [];
    let ready = false;
    return {
        get isReady() {
            return ready;
        },
        onReady(fn) {
            if (ready) {
                try {
                    fn();
                }
                catch (error) {
                    onError(error);
                }
                return;
            }
            queued.push(fn);
        },
        fire() {
            if (ready) {
                return;
            }
            ready = true;
            const drained = queued.splice(0, queued.length);
            for (const fn of drained) {
                try {
                    fn();
                }
                catch (error) {
                    onError(error);
                }
            }
        },
    };
};
exports.createReadyQueue = createReadyQueue;
